import styled, { createGlobalStyle } from "styled-components";

export default createGlobalStyle`
    * {
        margin: 0;
        padding: 0;
        outline: none;
        box-sizing: border-box;
        font-family: "Montserrat", Sans-serif;
    }

    body {
        font-family: sans-serif;
        background: #fff;
    }

    html, border-style, #root {
        height: 100%;
    }

    a {
        text-decoration: none;
        color: #000;
    }

    .ql-container {
      min-height: 150px;
    }
`;

export const Container = styled.section`
  background: #fff;
  margin: 30px auto;
  padding: 30px;
  border-radius: 4px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  align-items: center;
  justify-content: center;
  min-width: 400px;

  @media (max-width: 450px) {
    width: 100%;
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;

  label {
    font-size: 0.9rem;
    margin-bottom: 3px;
    color: #104467;
    align-self: flex-start;
  }

  input {
    height: 50px;
    padding: 0 10px;
    border-radius: 4px;
    border: 1px solid rgba(16, 68, 103, 0.34);
  }

  textarea {
    height: 150px;
    padding: 5px 10px;
    border-radius: 4px;
    border: 1px solid rgba(16, 68, 103, 0.34);
  }

  .erro {
    color: red;
    margin-top: 20px;
    display: flex;
    justify-content: center;
    font-size: 15px;
    align-self: start;
  }
`;

export const RequiredField = styled.span`
  color: red;
  margin-left: 4px;
  cursor: help;
`;

export const WarningInputMessage = styled.span`
  color: red;
  font-size: 13px;
  align-self: flex-start;

  &:hover {
    cursor: default;
  }
`;

export const ErroContainer = styled.div`
  color: red;
  margin: 10px 0;
  display: flex;
  justify-content: center;
  font-size: 15px;
  align-self: start;
`;
